<template>
  <div class="main" v-loading="loading">
    <div>
      <div class="operation">
        <el-button @click="is_dio = true">筛选</el-button>
        <el-button
          style="float: right"
          type="success"
          @click="distributionChange"
          >分配</el-button
        >
      </div>
      <el-table
        :data="tableData"
        @row-click="linkdetail"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          prop="agent_company"
          label="分配公司"
        ></el-table-column>
        <el-table-column prop="account_access" label="注册来源">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.account_access == 1" type="success"
              >抖 音</el-tag
            >
            <el-tag v-if="scope.row.account_access == 0" type="warning"
              >微 信</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="license_company_name"
          label="营业执照公司名"
        ></el-table-column>
        <el-table-column
          fixed
          prop="contact_name"
          label="联系人姓名"
        ></el-table-column>
        <el-table-column prop="username" label="手机号"></el-table-column>
        <el-table-column prop="city" label="公司所在区域"></el-table-column>
        <el-table-column
          prop="registration_status"
          :formatter="registration_statusFormat"
          label="审核状态"
        ></el-table-column>
        <el-table-column
          prop="create_time"
          label="注册提交时间"
        ></el-table-column>
        <el-table-column label="操作" width="100px">
          <template slot-scope="scope">
            <el-button
              @click.stop="withdraw(scope.row)"
              type="warning"
              size="small"
              >撤回</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="筛选"
      :visible.sync="is_dio"
      width="30%"
      :before-close="
        () => {
          is_dio = false;
        }
      "
    >
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="用户帐号">
          <el-input v-model="form.username" type="number"></el-input>
        </el-form-item>
        <el-form-item label="公司名称">
          <el-input v-model="form.license_company_name"></el-input>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select v-model="form.registration_status">
            <el-option label="未审核" :value="0"></el-option>
            <el-option label="不通过" :value="1"></el-option>
            <el-option label="通过" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公司所在地区">
          <el-cascader
            v-model="company_city"
            :options="company_options"
          ></el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            form = {};
            company_city = '';
          "
          >清空</el-button
        >
        <el-button @click="is_dio = false">取 消</el-button>
        <el-button type="primary" @click="shaiYes">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="分配代理商"
      :visible.sync="is_distribution"
      width="30%"
      :before-close="
        () => {
          is_distribution = false;
        }
      "
    >
      <el-form label-width="100px">
        <el-form-item label="分配公司">
          <el-select v-model="distributionCompany" filterable>
            <el-option
              v-for="(item, i) in disOption"
              :key="i"
              :label="item.company_name"
              :value="item.agent_id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="is_distribution = false">取 消</el-button>
        <el-button type="primary" @click="distributionYes">确 定</el-button>
      </span>
    </el-dialog>
    <div class="page">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        :total="table_num"
        :current-page="currentPage1"
        hide-on-single-page
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { require } from "@/utils/http_request.js";
export default {
  data() {
    return {
      tableData: [],
      pagesize: 15,
      currentPage1: 1,
      table_num: 0,
      is_dio: false,
      form: {},
      company_city: "",
      company_options: [],
      loading: true,
      is_distribution: false,
      distributionCompany: "",
      seletList: [],
      disOption: [],
    };
  },

  created() {
    require("post", "/commonality/v1/show_place_json/", { is_add: 1 }).then(
      (res) => {
        if (!res.code) {
          let add = res.data;
          for (let i = 0; i < add.length; i++) {
            for (let j = 0; j < add[i].children.length; j++) {
              delete add[i].children[j]["children"];
            }
          }
          this.company_options = add;
        }
      }
    );
    require("post", "/hr24_user/v1/show_agent_list/", {}).then((res) => {
      if (!res.code) {
        this.disOption = res.data;
      }
    });
    this.init(0);
  },

  methods: {
    distributionChange() {
      if (this.seletList.length == 0) {
        this.$message.warning("请选择分配客户");
        // this.is_distribution=false
        return false;
      }
      this.is_distribution = true;
    },
    handleSelectionChange(val) {
      this.seletList = [];
      console.log(val);
      val.map((item) => {
        this.seletList.push(item.user_detail_id);
      });
    },
    distributionYes() {
      let obj = {
        user_detail_list: this.seletList,
        agent_id: this.distributionCompany,
      };
      require("post", "/hr24_user/v1/register_user_allocation/", obj).then(
        (res) => {
          if (!res.code) {
            this.is_distribution = false;
            this.init(this.currentPage1 - 1);
          }
        }
      );
    },
    withdraw(data) {
      this.$confirm("此操作将永久撤回注册, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          require("post", "/hr24_user/v1/user_check_backout/", {
            register_id: data.id,
          }).then((res) => {
            if (!res.code) {
              this.$message.success("撤回成功！");
              this.init(this.currentPage1 - 1);
            }
          });
        })
        .catch(() => {});
      // console.log(data);
    },
    // 列表请求
    async init(page) {
      let province_id_list = [];
      let obj = { search_data: this.form, page };

      if (this.$cookies.get("auth_grade") == 61) {
        await require("post", "/lufish_user/v1/service_agent_province/", {}).then(
          (res) => {
            if (!res.code) {
              console.log(res);
              province_id_list = res.data;
              console.log("province_id_list", province_id_list, obj);
              obj.search_data.province_id_list = province_id_list;
            }
          }
        );
      }

      require("post", "/hr24_user/v1/user_reg_list/", obj).then((res) => {
        if (!res.code) {
          this.tableData = res.data.register_list.map((item, index) => {
            item.city = item.province_name + item.city_name;
            return item;
          });
          this.table_num = res.register_count;
          this.is_dio = false;
          this.loading = false;
        } else {
        }
      });
    },
    //筛选确定
    shaiYes() {
      console.log(this.form.license_company_place, this.company_city);
      if (this.company_city) {
        this.form.city_id = this.company_city[this.company_city.length - 1];
      }
      this.loading = true;
      this.init(0);
    },
    // 格式化状态字段
    registration_statusFormat(row, column) {
      if (row.registration_status === 0) {
        return "未处理";
      }
      if (row.registration_status === 1) {
        return "不通过";
      }
      if (row.registration_status === 2) {
        return "通过";
      }
    },

    handleCurrentChange(val) {
      this.currentPage1 = val;
      console.log(`当前页: ${val}`, this.currentPage1);
      this.loading = true;
      this.init(val - 1);
    },

    linkdetail(e) {
      console.log(11, e);
      this.$router.push({ path: "/auit_detail", query: { id: e.username } });
    },
  },
};
</script>

<style scoped>
.elb {
  margin-top: 100px;
}

/* .el-button--mini,
.el-button--small {
  width: 100%;
} */

.el-table td,
.el-table th {
  padding: 0;
  text-align: center;
}
.el-table--mini,
.el-table--small,
.el-table__expand-icon {
  font-size: 14px;
}
.operation {
  padding: 12px;
}
.page {
  text-align: center;
  padding: 12px 0;
}
</style>



// WEBPACK FOOTER //
// src/user_management/auit_resume.vue